import React from 'react';
import { formatDateTime } from './constants';

const AcademicTimelinePanel = ({ events }) => (
  <div className="space-y-2" data-testid="academic-timeline-list">
    {events.length === 0 ? (
      <p className="text-sm text-gray-500 text-center py-6">No academic activity recorded for this athlete yet.</p>
    ) : events.map((e, idx) => (
      <div key={`${e.target_id}-${idx}`} className="border-l-2 border-emerald-300 pl-3 py-1" data-testid={`timeline-event-${idx}`}>
        <p className="text-[11px] text-gray-400">{formatDateTime(e.timestamp)} · {e.actor_name || 'system'} {e.actor_role ? `(${e.actor_role})` : ''}</p>
        <p className="text-sm text-gray-800 dark:text-gray-200 mt-0.5">
          <span className="font-medium">{e.action?.replace(/^academic_/, '').replace(/_/g, ' ')}</span>
          {e.target_label ? ` — ${e.target_label}` : ''}
        </p>
        {e.description && <p className="text-xs text-gray-500 mt-0.5">{e.description}</p>}
      </div>
    ))}
  </div>
);

export default AcademicTimelinePanel;
